'use strict';

const DriverV3 = require('../../HomeyAPIV3/ManagerDrivers/Driver');

class Driver extends DriverV3 {

  static transformGet(item) {
    item = super.transformGet(item);

    item.ownerId = item.id;
    item.ownerUri = item.uri;
    item.ownerName = item.uriObj.name;
    item.ownerIconObj = item.uriObj.iconObj;
    item.color = item.uriObj.color;
    item.id = `${item.uri}:${item.id}`;

    delete item.uri;
    delete item.uriObj;

    return item;
  }
  
}

module.exports = Driver;
